import { Model } from '../core/base.model';

export class CustomDeductionType extends Model {
    protected static _resource = 'payroll/deductionTypes/requestCustomDeductionType';

    protected static _version = 'v2';

    protected static _serializeAttributes = ['name', 'description'];

    get name(): string {
        return this._attributes['name'];
    }
    set name(val: string) {
        this._attributes['name'] = val;
    }

    get description(): string {
        return this._attributes['description'];
    }
    set description(value: string) {
        this._attributes['description'] = value;
    }

    get employeePretax(): boolean {
        return this._attributes['employeePretax'];
    }
    set employeePretax(value: boolean) {
        this._attributes['employeePretax'] = value;
    }

    get employeeVacationPay(): boolean {
        return this._attributes['employeeVacationPay'];
    }
    set employeeVacationPay(value: boolean) {
        this._attributes['employeeVacationPay'] = value;
    }

    get employeeInsurableHours(): boolean {
        return this._attributes['employeeInsurableHours'];
    }
    set employeeInsurableHours(value: boolean) {
        this._attributes['employeeInsurableHours'] = value;
    }

    get employeeInsurableEarnings(): boolean {
        return this._attributes['employeeInsurableEarnings'];
    }
    set employeeInsurableEarnings(value: boolean) {
        this._attributes['employeeInsurableEarnings'] = value;
    }

    get employerTaxable(): boolean {
        return this._attributes['employerTaxable'];
    }
    set employerTaxable(value: boolean) {
        this._attributes['employerTaxable'] = value;
    }

    get employerPensionable(): boolean {
        return this._attributes['employerPensionable'];
    }
    set employerPensionable(value: boolean) {
        this._attributes['employerPensionable'] = value;
    }

    get employerInsurable(): boolean {
        return this._attributes['employerInsurable'];
    }
    set employerInsurable(value: boolean) {
        this._attributes['employerInsurable'] = value;
    }

    get employerTax(): boolean {
        return this._attributes['employerTax'];
    }
    set employerTax(value: boolean) {
        this._attributes['employerTax'] = value;
    }
}
